import React, { useContext, useEffect, useState } from "react";
import { layoutCardRadius, layoutPillRadius } from "../theme/colors";
import { campaignsPathTo, providersPathTo } from "../utils/Api";
import { Box, ButtonBase, InputBase, Typography, Badge, Stack } from "@mui/material";
import ProviderCard from "./building_blocks/ProviderCard";
import ProductCard from "./building_blocks/ProductCard";
import WelcomeCarousel from "./WelcomeCarousel";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useNavigate } from "react-router-dom";
import SnackbarContext from '../contexts/SnackbarContext';

/*Icons*/
import LocationOnIcon from '@mui/icons-material/LocationOn';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import SearchIcon from '@mui/icons-material/Search';

const Home = () => {
  const [providers, setProviders] = useState([]);
  const navigate = useNavigate()
  const [defaultAddress, setDefaultAddress] = useState()
  const [hasItemsInCart, setHasItemsInCart] = useState(false);
  const [campaignShowcase, setCampaignShowcase] = useState(null);
  const { openSnackbar } = useContext(SnackbarContext);

  useEffect(() => {
    const checkCartItems = () => {
      const cartProducts = JSON.parse(localStorage.getItem('shoppingCartProducts') || '[]');
      setHasItemsInCart(cartProducts.length > 0);
    };

    checkCartItems();

    window.addEventListener('storage', checkCartItems);

    return () => {
      window.removeEventListener('storage', checkCartItems);
    };
  }, []);

  useEffect(() => {
    providersPathTo.list().then(result => {
      setProviders(result.data);
    });
    campaignsPathTo.active()
      .then(result => setCampaignShowcase(result.data))
      .catch(() => setCampaignShowcase(null));

    const storedUser = JSON.parse(localStorage.getItem('current_user'));
    if (storedUser?.default_address) {
      setDefaultAddress(storedUser.default_address)
    }
  }, []);

  useEffect(() => {
    document.title = 'Home - TudoPets.app - Marketplace Pet de Curitiba';
  }, []);

  const handleCartClick = () => {
    if (hasItemsInCart) {
      navigate(`/shopping-cart`);
    } else {
      openSnackbar('Não há itens no carrinho', 'info');
    }
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>

      {/*Endereço e Carrinho*/}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', alignSelf: 'stretch' }}>
        {/* Endereço */}
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 1 }}>
          <Typography variant="sectionTitle">Endereço</Typography>

          <ButtonBase data-no-shadow="true" onClick={() => navigate('/addresses', { state: { returnTo: '/home' } })}
            sx={{ display: 'flex', alignItems: 'center', borderRadius: layoutCardRadius, gap: 0.5, p: 0.5, alignSelf: 'stretch', cursor: 'pointer', color: 'text.primary' }}>

            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
              <LocationOnIcon />
              {!defaultAddress && (
                <Typography sx={{ fontFamily: 'Nunito', fontSize: '16px', fontWeight: 600, lineHeight: '16px' }}>
                  Adicionar endereço de entrega
                </Typography>
              )}
              {defaultAddress && (
                <Box>
                  <Typography sx={{ fontFamily: 'Nunito', fontSize: '16px', fontWeight: 600, lineHeight: '16px' }}>
                    {defaultAddress.logradouro}, {defaultAddress.numero}
                  </Typography>
                </Box>
              )}
            </Box>
            <ExpandMoreIcon />
          </ButtonBase>
        </Box>

        {/* Carrinho com bolinha — bottom nav vem do RouterLayer */}
        <Badge
          variant="dot"
          color="error"
          invisible={!hasItemsInCart}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          sx={{
            '& .MuiBadge-dot': {
              width: '12px',
              height: '12px',
              borderRadius: '50%',
              bgcolor: 'error.main',
              transform: 'translate(-20%, 20%)',
            }

          }}
        >
          <ButtonBase
            sx={{
              display: 'flex',
              p: 2,
              justifyContent: 'center',
              alignItems: 'center',
              gap: 1,
              borderRadius: '50%',
              bgcolor: 'surface.card',
              cursor: 'pointer',
            }}
            onClick={handleCartClick}
          >
            <ShoppingCartIcon sx={{ color: 'text.secondary' }} />
          </ButtonBase>
        </Badge>
      </Box>

      {/* Barra de Pesquisa */}
      <ButtonBase
        component="div"
        onClick={() => navigate('/search')}
        sx={{ display: 'flex', p: '4px 4px 4px 16px', justifyContent: 'space-between', alignItems: 'center', alignSelf: 'stretch', borderRadius: layoutPillRadius, bgcolor: 'surface.card', cursor: 'pointer', width: '100%' }}
      >
        <InputBase
          readOnly
          sx={{ width: '100%', pointerEvents: 'none' }}
          placeholder="O que você procura hoje?"
        />
        <ButtonBase data-no-shadow="true" sx={{ display: 'flex', p: '13px', justifyContent: 'center', alignItems: 'center', gap: 1, bgcolor: 'surface.input', borderRadius: '50%' }}>
          <SearchIcon sx={{ color: 'text.primary' }} />
        </ButtonBase>
      </ButtonBase>

      {/* Carrrossel */} {/* Teste */}
      <Box sx={{
        width: { xs: 'calc(100% + 32px)', sm: '100%' },
        mx: { xs: -2, sm: 0 },
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}>
        <WelcomeCarousel />
      </Box>

      {campaignShowcase?.products?.length > 0 && (
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 2, alignSelf: 'stretch' }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 0.5 }}>
            <Typography variant="sectionTitle"><b>{campaignShowcase.campaign.name}</b></Typography>
            <Typography sx={{ fontFamily: 'Nunito', fontSize: '14px', lineHeight: '21px', color: 'text.secondary' }}>
              Produtos em destaque das lojas participantes.
            </Typography>
          </Box>

          <Box
            sx={{
              position: 'relative',
              width: '100%',
              maxWidth: '100%',
            }}
          >
            <Stack
              direction="row"
              sx={{
                display: 'flex',
                alignItems: 'stretch',
                gap: 1,
                width: '100%',
                maxWidth: '100%',
                overflowX: 'auto',
                overflowY: 'hidden',
                whiteSpace: 'nowrap',
                pb: 0.5,
                boxSizing: 'border-box',
                scrollbarWidth: 'thin',
                '&::-webkit-scrollbar': { height: '8px' },
                '&::-webkit-scrollbar-thumb': { backgroundColor: 'rgba(0,0,0,0.3)' },
                '&::after': {
                  content: '""',
                  flex: '0 0 32px',
                },
              }}
            >
              {campaignShowcase.products.map((product) => (
                <ButtonBase
                  key={product.id}
                  onClick={() => navigate(`/provider/${product.provider_id}`)}
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'stretch',
                    flex: '0 0 auto',
                    width: '172.5px',
                    minWidth: '172.5px',
                    textAlign: 'left',
                    borderRadius: layoutCardRadius,
                    overflow: 'hidden',
                  }}
                >
                  <ProductCard
                    product={product}
                    variant="white"
                    detailMode="weight"
                    sx={{ width: '100%', minWidth: '100%', boxSizing: 'border-box' }}
                  />
                </ButtonBase>
              ))}
            </Stack>
          </Box>
        </Box>
      )}

      {/* Categorias */}
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 2, alignSelf: 'stretch' }}>

        {/* Lojas */}
        <Typography variant="sectionTitle">Todas as lojas</Typography>
        <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'stretch', gap: 2 }}>
          {providers.map((provider) => (
            <Box key={provider.id}>
              <ProviderCard
                provider={provider}
                onCardClick={() => navigate(`/provider/${provider.id}`)}
                showProducts={false}
                categories={true}
                showBanner={true}
              />
            </Box>
          ))}
        </Box>
      </Box>
    </Box >
  );
};

export default Home;
